/*
 * @Author: 晋枫
 * @Date: 2021-09-25 19:22:37
 * @LastEditTime: 2021-09-27 16:06:29
 * @LastEditors: 晋枫
 * @Description:
 * @FilePath: /jmj-7v1-task/src/router/modules/bulletinBoard/business.js
 * 🍁YOU CAN（NOT）REDO🍁
 */
import productionRouter from './production'
import engineeringRouter from './engineering'
import organizationalCapabilityRouter from './organizationalCapability'
import salesRouter from './sales'
import { routeAddWorkOrderId, WORK_ORDER_TYPES } from '@/views/wxapp/bulletin-board/workbench-v2/constant'

const businessRouter = [

  {
    path: 'empowerment-card',
    name: 'EmpowermentCard',
    component: () => import('@/views/wxapp/bulletin-board/empowerment-card'),
    meta: {
      title: '业务看板'
    }
  },
  {
    path: 'empowerment-visual',
    name: 'EmpowermentVisual',
    component: () => import('@/views/wxapp/bulletin-board/empowerment-visual/index'),
    meta: {
      title: ''
    }
  },
  ...productionRouter,
  ...engineeringRouter,
  ...organizationalCapabilityRouter,
  ...salesRouter
]
export default routeAddWorkOrderId(businessRouter, WORK_ORDER_TYPES.BUSINESS)
